import BasePage from '../../../../../components/table_page';
import Form from './form';
import ScanList from './form/scan_list.vue';

export default {
  name: 'banquet_group',
  extends: BasePage,
  data() {
    return {
      params: {
        banquetSource: '2', // 宴席类型 1-普通宴席 2-团购宴席
      },
    };
  },
  components: {
    Form,
    ScanList,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveStatus } = row;
      if (code === 'edit' && (approveStatus !== '0' && approveStatus !== '3')) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
      if (val.code === 'scan_code_record') {
        this.formName = 'ScanList';
        this.propsObjInData.row = { banquetCode: row.banquetCode };
        this.modalConfig.title = '扫码记录';
        this.openFull();
      }
    },
  },
};
